import React, { useContext, useState, useMemo } from 'react';
import { bool, object } from 'prop-types';

import '../styles/ChildCategories.css';
import { Link } from 'react-router-dom';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import AppContext from './context/AppContext';
import BsImage from '../icons/BsImage';

const MIN_CATEGORIES = 8;

function ChildCategories ({ hierarchy, isMobile }) {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const [showAll, setShowAll] = useState(false);
    
    const allSubCategories = useMemo(() => 
        hierarchy.default?.filter((category) => category.LEVEL === 2) || []
    , [hierarchy.default]);
    
    const current = useMemo(() => 
        allSubCategories
            .sort((a, b) => a.title.localeCompare(b.title))
            .slice(0, showAll ? undefined : MIN_CATEGORIES)
    , [allSubCategories, showAll]);
    
    const shouldShowMoreButton = useMemo(() => 
        allSubCategories.length > MIN_CATEGORIES
    , [allSubCategories]);

    if (!allSubCategories.length) {
        return null;
    }

    return (
        <div>
            {!isMobile ? (
                <h6
                    className={'child-categories-headline'}
                >
                    SUB CATEGORIES
                </h6>
            ): null}
            <ul
                className={'child-categories-container'}
            >
                {current.map(({ id, title, handle, images = [] }) => (<li
                    className={'child-categories-item'}
                    key={id}
                >
                    <Link
                        className={'custom-link'}
                        to={`${collectionPath[0].pathBeforeParams}/${handle}`}
                    >
                        <div
                            className={'child-categories-image-container'}
                        >
                            {images[0] ? (
                                <img
                                    className={'child-categories-image'}
                                    src={images[0]}
                                    alt={title}
                                />
                            ) : (
                                <div
                                    className={'child-categories-image-placeholder'}
                                >
                                    <BsImage
                                        className={'child-categories-image-icon'}
                                    />
                                </div>
                            )}
                        </div>
                        <div
                            className={'child-categories-title'}
                        >
                            {title}
                        </div>
                    </Link>
                </li>))
                }
                {shouldShowMoreButton && (
                    <li 
                        className={'child-categories-item'}
                    >
                        <button
                            className={'child-categories-button'}
                            onClick={() => setShowAll(!showAll)}
                        >
                            <div 
                                className={'child-categories-button-content'}
                            >
                                <div 
                                    className={'child-categories-button-icon'}
                                >
                                    {showAll ? '−' : '+'}
                                </div>
                                <div 
                                    className={'child-categories-button-text'}
                                >
                                    {showAll ? 'LESS' : 'MORE'}
                                </div>
                            </div>
                        </button>
                    </li>
                )}
            </ul>

        </div>
    );
}

ChildCategories.propTypes = {
    hierarchy: object,
    isMobile: bool,
};

export default ChildCategories;